"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonVisitedPlacesConfirmNextSection = exports.buttonDeleteVisitedPlace = exports.buttonCancelVisitedPlace = exports.buttonSaveVisitedPlace = exports.visitedPlaceDepartureTime = exports.visitedPlaceNextPlaceCategory = exports.visitedPlaceArrivalTime = exports.visitedPlacePreviousDepartureTime = exports.visitedPlacePreviousArrivalTime = exports.visitedPlacePreviousPreviousDepartureTime = exports.visitedPlaceGeography = exports.visitedPlaceName = exports.visitedPlaceShortcut = exports.visitedPlaceOnTheRoadDepartureType = exports.visitedPlaceActivity = exports.visitedPlaceActivityCategory = exports.personVisitedPlaces = exports.personVisitedPlacesMap = exports.personVisitedPlacesTitle = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const get_1 = __importDefault(require("lodash/get"));
const truncate_1 = __importDefault(require("lodash/truncate"));
const max_1 = __importDefault(require("lodash/max"));
const min_1 = __importDefault(require("lodash/min"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const escape_1 = __importDefault(require("lodash/escape"));
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const widgetPersonVisitedPlacesMap_1 = require("evolution-common/lib/services/questionnaire/sections/common/widgetPersonVisitedPlacesMap");
const activityIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/visitedPlaces/activityIconMapping");
const helper_1 = require("../../common/helper");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const i18n_config_1 = __importDefault(require("evolution-frontend/lib/config/i18n.config"));
const types_1 = require("evolution-common/lib/services/odSurvey/types");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const customFrontendHelper_1 = require("../../common/customFrontendHelper");
const defaultInputBase_1 = require("evolution-frontend/lib/components/inputs/defaultInputBase");
const widgetsNames_1 = require("./widgetsNames");
const widgetsSwitchPerson_1 = require("evolution-common/lib/services/questionnaire/sections/common/widgetsSwitchPerson");
const customValidations_1 = require("../../common/customValidations");
const switchPersonWidgets = (0, widgetsSwitchPerson_1.getSwitchPersonWidgets)();
exports.activePersonTitle = switchPersonWidgets.activePersonTitle;
exports.buttonSwitchPerson = switchPersonWidgets.buttonSwitchPerson;
// FIXME Allow to configure the earliest and latest time
const MIN_SECONDS_SINCE_MIDNIGHT = 4 * 60 * 60; // 4 AM
const MAX_SECONDS_SINCE_MIDNIGHT = 24 * 60 * 60 + MIN_SECONDS_SINCE_MIDNIGHT; // 4 AM the next day
exports.personVisitedPlacesTitle = {
    type: 'text',
    path: 'household.persons.{_activePersonId}.personVisitedPlacesTitle',
    align: 'left',
    containsHtml: true,
    text: (t, interview) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const assignedDay = (0, helpers_1.getResponse)(interview, '_assignedDay');
        const assignedDate = (0, frontendHelper_1.getFormattedDate)(assignedDay, { withDayOfWeek: true, withRelative: true });
        return t('visitedPlaces:personVisitedPlacesTitle', {
            nickname: (0, escape_1.default)(person.nickname),
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            assignedDate,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    }
};
// FIXME: See if the maps takes into account the moving activities which were in 2024, but not yet in evolution
exports.personVisitedPlacesMap = (0, widgetPersonVisitedPlacesMap_1.getPersonVisitedPlacesMapConfig)({ getFormattedDate: frontendHelper_1.getFormattedDate });
exports.personVisitedPlaces = {
    type: 'group',
    path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.visitedPlaces',
    title: {
        fr: 'Lieux visités',
        en: 'Visited places'
    },
    filter: function (interview, groupedObjects) {
        const journey = odSurveyHelpers.getActiveJourney({ interview }); // Ensure the active journey is set
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        if (activeVisitedPlace) {
            const filteredGroupedObject = {};
            for (const groupedObjectId in groupedObjects) {
                if (groupedObjectId === activeVisitedPlace._uuid) {
                    filteredGroupedObject[groupedObjectId] = groupedObjects[groupedObjectId];
                }
            }
            return filteredGroupedObject;
        }
        else {
            return {};
        }
    },
    name: (t, groupedObject, sequence) => {
        return `${t('visitedPlaces:VisitedPlaceSequence', { count: sequence })} ${groupedObject.name
            ? `• **${groupedObject.name}**`
            : groupedObject.activity
                ? `• **${t(`survey:visitedPlace:activities:${groupedObject.activity}`)}**`
                : ''}`;
    },
    showGroupedObjectDeleteButton: false,
    deleteConfirmPopup: {
        content: (t) => t('visitedPlaces:ConfirmDeleteVisitedPlace')
    },
    showGroupedObjectAddButton: true,
    addButtonLocation: 'both',
    widgets: widgetsNames_1.personVisitedPlacesWidgetsNames
};
exports.visitedPlaceActivityCategory = {
    type: 'question',
    path: 'activityCategory',
    inputType: 'radio',
    datatype: 'string',
    columns: 2,
    containsHtml: true,
    useAssignedValueOnHide: true,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview, person });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        const firstVisitedPlace = visitedPlacesArray[0];
        const secondVisitedPlace = visitedPlacesArray[1];
        if (firstVisitedPlace && firstVisitedPlace._uuid === activeVisitedPlace._uuid) {
            return t('visitedPlaces:ActivityCategoryFirstLocation');
        }
        else if (firstVisitedPlace &&
            secondVisitedPlace &&
            firstVisitedPlace.activity === 'home' &&
            secondVisitedPlace._uuid === activeVisitedPlace._uuid) {
            return t('visitedPlaces:ActivityCategoryAfterHome');
        }
        else {
            return t('visitedPlaces:ActivityCategory');
        }
    },
    choices: [
        {
            value: 'home',
            label: (t) => t('survey:visitedPlace:activityCategories:home'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('home'),
            conditional: function (interview, path) {
                // hide if previous visited place is home:
                const person = odSurveyHelpers.getPerson({ interview });
                const journey = odSurveyHelpers.getActiveJourney({ interview, person });
                const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
                const nextVisitedPlace = odSurveyHelpers.getNextVisitedPlace({
                    journey,
                    visitedPlaceId: activeVisitedPlace._uuid
                });
                const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
                    journey,
                    visitedPlaceId: activeVisitedPlace._uuid
                });
                return ((!previousVisitedPlace ||
                    (previousVisitedPlace && previousVisitedPlace.activityCategory !== 'home')) &&
                    (!nextVisitedPlace || (nextVisitedPlace && nextVisitedPlace.activityCategory !== 'home')));
            }
        },
        {
            value: 'work',
            label: (t) => t('survey:visitedPlace:activityCategories:work'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('work'),
            conditional: function (interview, path) {
                // hide if younger than 15:
                const person = odSurveyHelpers.getPerson({ interview });
                return person.age && person.age >= 15;
            }
        },
        {
            value: 'school',
            label: (t, interview) => {
                const person = odSurveyHelpers.getPerson({ interview });
                if (person.schoolType && person.schoolType === 'childcare') {
                    return t('survey:visitedPlace:activityCategories:childcare');
                }
                else if (person.schoolType && person.schoolType === 'kindergarten') {
                    return t('survey:visitedPlace:activityCategories:kindergarten');
                }
                else if (person.schoolType &&
                    (person.schoolType === 'kindergartenFor4YearsOld' ||
                        person.schoolType === 'primarySchool' ||
                        person.schoolType === 'secondarySchool')) {
                    return t('survey:visitedPlace:activityCategories:school');
                }
                else {
                    return t('survey:visitedPlace:activityCategories:schoolStudies');
                }
            },
            conditional: function (interview, path) {
                const person = odSurveyHelpers.getPerson({ interview });
                const occupation = person.occupation;
                return (person.age &&
                    person.age >= 5 &&
                    ([
                        'fullTimeWorker',
                        'partTimeWorker',
                        'fullTimeStudent',
                        'partTimeStudent',
                        'workerAndStudent'
                    ].includes(occupation) ||
                        (0, helper_1.isStudentFromEnrolled)(person)));
            },
            iconPath: (0, activityIconMapping_1.getActivityIcon)('school')
        },
        {
            value: 'shoppingServiceRestaurant',
            label: (t) => t('survey:visitedPlace:activityCategories:shoppingServiceRestaurant'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('shoppingServiceRestaurant')
        },
        {
            value: 'dropFetchSomeone',
            label: (t) => t('survey:visitedPlace:activityCategories:dropFetchSomeone'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('dropFetchSomeone')
        },
        {
            value: 'leisure',
            label: (t) => t('survey:visitedPlace:activityCategories:leisure'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('leisure')
        },
        {
            value: 'otherParentHome',
            label: (t) => t('survey:visitedPlace:activityCategories:otherParentHome'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('otherParentHome'),
            conditional: function (interview, path) {
                // hide if previous visited place is home:
                const person = odSurveyHelpers.getPerson({ interview });
                const journey = odSurveyHelpers.getActiveJourney({ interview, person });
                const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
                const nextVisitedPlace = odSurveyHelpers.getNextVisitedPlace({
                    journey,
                    visitedPlaceId: activeVisitedPlace._uuid
                });
                const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
                    journey,
                    visitedPlaceId: activeVisitedPlace._uuid
                });
                return (person.age &&
                    person.age <= 16 &&
                    (!previousVisitedPlace || previousVisitedPlace.activityCategory !== 'otherParentHome') &&
                    (!nextVisitedPlace || nextVisitedPlace.activityCategory !== 'otherParentHome'));
            }
        },
        {
            value: 'other',
            label: (t) => t('survey:visitedPlace:activityCategories:other'),
            iconPath: (0, activityIconMapping_1.getActivityIcon)('other')
        }
    ],
    validations: function (value) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:activityIsRequiredError')
            }
        ];
    },
    conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        return [
            activeVisitedPlace._isNew === false || activeVisitedPlace.activityCategory !== 'home',
            activeVisitedPlace.activityCategory
        ];
    }
};
// Validate that the next or previous visited place are not in the incompatible activities list
const validatePreviousNextPlaceIsNotActivities = ({ interview, incompatibleActivities }) => {
    const journey = odSurveyHelpers.getActiveJourney({ interview });
    const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
    const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
        journey,
        visitedPlaceId: visitedPlace._uuid
    });
    const nextVisitedPlace = odSurveyHelpers.getNextVisitedPlace({
        journey,
        visitedPlaceId: visitedPlace._uuid
    });
    return ((!previousVisitedPlace ||
        (previousVisitedPlace && !incompatibleActivities.includes(previousVisitedPlace.activity))) &&
        (!nextVisitedPlace || (nextVisitedPlace && !incompatibleActivities.includes(nextVisitedPlace.activity))));
};
const visitedPlaceActivityChoices = [
    {
        value: 'workUsual',
        label: (t) => t('survey:visitedPlace:activities:workUsual'),
        iconPath: (0, activityIconMapping_1.getActivityIcon)('workUsual'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            const occupation = person.occupation;
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (activityCategory === 'work' &&
                person.usualWorkPlace &&
                person.usualWorkPlace.geography &&
                ['fullTimeWorker', 'partTimeWorker', 'workerAndStudent'].includes(occupation) &&
                validatePreviousNextPlaceIsNotActivities({ interview, incompatibleActivities: ['workUsual'] }));
        }
    },
    {
        value: 'workNotUsual',
        label: (t) => t('survey:visitedPlace:activities:workNotUsual'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'work';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('workNotUsual')
    },
    {
        value: 'workOnTheRoad',
        label: (t) => t('survey:visitedPlace:activities:workOnTheRoad'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (activityCategory === 'work' &&
                validatePreviousNextPlaceIsNotActivities({ interview, incompatibleActivities: types_1.loopActivities }));
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('workOnTheRoad')
    },
    {
        value: 'schoolUsual',
        label: (t) => t('survey:visitedPlace:activities:schoolUsual'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            const occupation = person.occupation;
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            if (activityCategory === 'school' &&
                (person.schoolType === 'kindergarten' || person.schoolType === 'childcare')) {
                return true;
            }
            return (person.usualSchoolPlace &&
                activityCategory === 'school' &&
                (['fullTimeStudent', 'partTimeStudent', 'workerAndStudent'].includes(occupation) ||
                    (person.age && person.age <= 15)) &&
                validatePreviousNextPlaceIsNotActivities({ interview, incompatibleActivities: ['schoolUsual'] }));
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('schoolUsual')
    },
    {
        value: 'schoolNotUsual',
        label: (t) => t('survey:visitedPlace:activities:schoolNotUsual'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'school';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('schoolNotUsual')
    },
    {
        value: 'shopping',
        label: (t) => t('survey:visitedPlace:activities:shopping'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'shoppingServiceRestaurant';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('shopping')
    },
    {
        value: 'restaurant',
        label: (t) => t('survey:visitedPlace:activities:restaurant'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (activityCategory === 'shoppingServiceRestaurant' ||
                activityCategory === 'leisure' ||
                activityCategory === 'other');
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('restaurant')
    },
    {
        value: 'service',
        label: (t) => t('survey:visitedPlace:activities:service'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'shoppingServiceRestaurant' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('service')
    },
    {
        value: 'dropSomeone',
        label: (t) => t('survey:visitedPlace:activities:dropSomeone'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'dropFetchSomeone' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('dropSomeone')
    },
    {
        value: 'fetchSomeone',
        label: (t) => t('survey:visitedPlace:activities:fetchSomeone'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'dropFetchSomeone' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('fetchSomeone')
    },
    {
        value: 'accompanySomeone', // added in PR merged on 2023/09/11, added some days later in the production questionnaire
        label: (t) => t('survey:visitedPlace:activities:accompanySomeone'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'other' || activityCategory === 'dropFetchSomeone';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('accompanySomeone')
    },
    {
        value: 'leisureStroll',
        label: (t) => t('survey:visitedPlace:activities:leisureStroll'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return ((activityCategory === 'leisure' || activityCategory === 'other') &&
                validatePreviousNextPlaceIsNotActivities({ interview, incompatibleActivities: types_1.loopActivities }));
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('leisureStroll')
    },
    {
        value: 'leisureSports',
        label: (t) => t('survey:visitedPlace:activities:leisureSports'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'leisure';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('leisureSports')
    },
    {
        value: 'leisureArtsMusicCulture',
        label: (t) => t('survey:visitedPlace:activities:leisureArtsMusicCulture'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'leisure';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('leisureArtsMusicCulture')
    },
    {
        value: 'leisureTourism',
        label: (t) => t('survey:visitedPlace:activities:leisureTourism'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'leisure';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('leisureTourism')
    },
    {
        value: 'visiting',
        label: (t) => t('survey:visitedPlace:activities:visiting'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'leisure' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('visiting')
    },
    {
        value: 'medical',
        label: (t) => t('survey:visitedPlace:activities:medical'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'shoppingServiceRestaurant' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('medical')
    },
    {
        value: 'veterinarian',
        label: (t) => t('survey:visitedPlace:activities:veterinarian'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'shoppingServiceRestaurant' || activityCategory === 'other';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('veterinarian')
    },
    {
        value: 'worship',
        label: (t) => t('survey:visitedPlace:activities:worship'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (activityCategory === 'other' ||
                activityCategory === 'leisure' ||
                activityCategory === 'shoppingServiceRestaurant');
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('worship')
    },
    {
        value: 'volunteering',
        label: (t) => t('survey:visitedPlace:activities:volunteering'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'other' || activityCategory === 'work' || activityCategory === 'leisure';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('volunteering')
    },
    {
        value: 'secondaryHome',
        label: (t) => t('survey:visitedPlace:activities:secondaryHome'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'other' || activityCategory === 'leisure';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('secondaryHome')
    },
    {
        value: 'schoolNotStudent',
        label: (t) => t('survey:visitedPlace:activities:schoolNotStudent'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'other' && !(0, helper_1.isStudent)(person) && person.age && person.age >= 16;
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('schoolNotStudent')
    },
    {
        value: 'carElectricChargingStation',
        label: (t) => t('survey:visitedPlace:activities:carElectricChargingStation'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            const drivingLicenseOwnership = person ? person.drivingLicenseOwnership : 'dontKnow';
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (drivingLicenseOwnership === 'yes' &&
                (activityCategory === 'shoppingServiceRestaurant' || activityCategory === 'other'));
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('carElectricChargingStation')
    },
    {
        value: 'carsharingStation',
        label: (t) => t('survey:visitedPlace:activities:carsharingStation'),
        conditional: function (interview, path) {
            const carsharingMembersCount = (0, helper_1.carsharingMembersCountInHousehold)(interview);
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (carsharingMembersCount > 0 &&
                (activityCategory === 'shoppingServiceRestaurant' || activityCategory === 'other'));
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('carsharingStation')
    },
    {
        value: 'pickClassifiedPurchase',
        label: (t) => t('survey:visitedPlace:activities:pickClassifiedPurchase'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return activityCategory === 'other' || activityCategory === 'shoppingServiceRestaurant';
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('pickClassifiedPurchase')
    },
    {
        value: 'other',
        label: (t) => t('survey:visitedPlace:activities:other'),
        conditional: function (interview, path) {
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (activityCategory === 'other' ||
                activityCategory === 'shoppingServiceRestaurant' ||
                activityCategory === 'dropFetchSomeone' ||
                activityCategory === 'leisure');
        },
        iconPath: (0, activityIconMapping_1.getActivityIcon)('other')
    }
];
exports.visitedPlaceActivity = {
    type: 'question',
    path: 'activity',
    inputType: 'radio',
    datatype: 'string',
    containsHtml: true,
    columns: 2,
    label: (t, interview) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        return t('visitedPlaces:Activity', {
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    choices: visitedPlaceActivityChoices,
    validations: function (value, customValue, interview, path, customPath) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:activityIsRequiredError')
            }
        ];
    },
    conditional: function (interview, path) {
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        const activityCategory = visitedPlace.activityCategory;
        // Home is the only activity category that does not require sub-choices of activity types
        if ((0, LodashExtensions_1._isBlank)(activityCategory) || activityCategory === 'home' || activityCategory === 'otherParentHome') {
            return [false, activityCategory];
        }
        // If there is only one valid activity type, auto-select it and hide this question.
        // TODO: Fix cleanly in evolution. See https://github.com/chairemobilite/evolution/issues/110
        const activityChoices = visitedPlaceActivityChoices.filter((choice) => {
            return choice.conditional(interview, path) === true;
        });
        if (activityChoices.length === 1) {
            return [false, activityChoices[0].value];
        }
        // Otherwise, display the question.
        return [true, null];
    }
};
const visitedPlaceOnTheRoadDepartureTypeChoices = [
    {
        value: 'home',
        label: (t, interview, path) => t('survey:visitedPlace:onTheRoadDepartureTypeChoices:home')
    },
    {
        value: 'usualWorkPlace',
        label: (t, interview, path) => t('survey:visitedPlace:onTheRoadDepartureTypeChoices:usualWorkPlace'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getPerson({ interview });
            return person.workPlaceType === 'onTheRoadWithUsualPlace';
        }
    },
    {
        value: 'other',
        label: (t, interview, path) => {
            const journey = odSurveyHelpers.getActiveJourney({ interview });
            const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
            const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
                journey,
                visitedPlaceId: activeVisitedPlace._uuid
            });
            const previousVisitedPlaceDescription = previousVisitedPlace
                ? (0, frontendHelper_1.getVisitedPlaceDescription)(previousVisitedPlace, false, false)
                : undefined;
            return previousVisitedPlaceDescription
                ? previousVisitedPlaceDescription
                : t('survey:visitedPlace:onTheRoadDepartureTypeChoices:other');
        },
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getPerson({ interview });
            const journey = odSurveyHelpers.getActiveJourney({ interview });
            const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
            const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
                journey,
                visitedPlaceId: activeVisitedPlace._uuid
            });
            return ('home' !== previousVisitedPlace.activityCategory &&
                previousVisitedPlace.activity !== 'workOnTheRoad' &&
                !(previousVisitedPlace.activity === 'workUsual' && person.workPlaceType === 'onTheRoadWithUsualPlace'));
        }
    }
];
exports.visitedPlaceOnTheRoadDepartureType = {
    type: 'question',
    inputType: 'radio',
    path: 'onTheRoadDepartureType',
    datatype: 'string',
    twoColumns: false,
    sameLine: false,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = person.nickname;
        return t('visitedPlaces:onTheRoadDepartureType', {
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    choices: visitedPlaceOnTheRoadDepartureTypeChoices,
    validations: validations.requiredValidation,
    conditional: function (interview, path) {
        const sequence = (0, helpers_1.getResponse)(interview, path, null, '../_sequence');
        const isNew = (0, helpers_1.getResponse)(interview, path, null, '../_isNew');
        const visitedPlaceActivity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
        const condition = isNew !== false && sequence !== 1 && visitedPlaceActivity === 'workOnTheRoad';
        if (condition === false) {
            // Exit early
            return [condition, null];
        }
        // If there is only one valid departure location, auto-select it and hide this question.
        // TODO: Fix cleanly in evolution. See https://github.com/chairemobilite/evolution/issues/110
        const choices = visitedPlaceOnTheRoadDepartureTypeChoices.filter((choice) => {
            return !(0, LodashExtensions_1._isBlank)(choice.conditional) ? choice.conditional(interview, path) === true : true;
        });
        if (choices.length === 1) {
            return [false, choices[0].value];
        }
        // Otherwise, display the question.
        return [true, null];
    }
};
exports.visitedPlaceShortcut = {
    type: 'question',
    path: 'shortcut',
    inputType: 'select',
    datatype: 'string',
    twoColumns: false,
    containsHtml: true,
    label: (t, interview) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        return t('visitedPlaces:shortcut', {
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    choices: function (interview, path) {
        // Ne pas afficher si ce n'est pas une activité compatible
        const activity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
        const usualActivity = ['workUsual', 'schoolUsual'].includes(activity);
        // Si ce n'est pas une activité usuelle, afficher tous les shortcuts possibles
        if (!usualActivity) {
            const shortcuts = (0, customFrontendHelper_1.getShortcutVisitedPlaces)(interview);
            const choices = [];
            for (let i = 0, count = shortcuts.length; i < count; i++) {
                const shortcut = shortcuts[i];
                choices.push({
                    value: shortcut.visitedPlaceId,
                    label: {
                        fr: shortcut.description,
                        en: shortcut.description
                    }
                });
            }
            return choices;
        }
        // Si c'est une activité usuelle, afficher seulement les places du même type. Oui, c'est possible que qqn d'autre l'ait déjà localisé, mais pour ce type de lieu, on veut l'avoir de la personne elle-même
        const person = odSurveyHelpers.getPerson({ interview });
        const currentJourney = odSurveyHelpers.getActiveJourney({ interview, person });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey: currentJourney });
        const currentVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey: currentJourney });
        const previousSameActivities = visitedPlacesArray.filter((visitedPlace) => currentVisitedPlace._uuid !== visitedPlace._uuid &&
            visitedPlace.activity === activity &&
            visitedPlace.shortcut === undefined);
        return previousSameActivities.map((prevActivity) => ({
            value: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${prevActivity._uuid}`,
            label: (0, frontendHelper_1.getVisitedPlaceDescription)(prevActivity, false, false)
        }));
    },
    conditional: function (interview, path) {
        const activity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
        const visitedPlaceAlreadyVisited = (0, helpers_1.getResponse)(interview, path, null, '../alreadyVisitedBySelfOrAnotherHouseholdMember');
        return [!(0, LodashExtensions_1._isBlank)(activity) && visitedPlaceAlreadyVisited === 'yes', null];
    }
};
exports.visitedPlaceName = {
    type: 'question',
    path: 'name',
    inputType: 'string',
    datatype: 'string',
    containsHtml: true,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        let activity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
        if ((0, LodashExtensions_1._booleish)(person.workOnTheRoad) === true && activity === 'workUsual') {
            activity = 'workUsual_onTheRoadOften'; // Special case for this one. See CSV questionnaire
        }
        const key = 'visitedPlaces:LocationNameAddressExample_' + activity;
        const examples = t(key, { context: process.env.EV_VARIANT });
        const helpText = i18n_config_1.default.exists(key) && !(0, LodashExtensions_1._isBlank)(activity) && !(0, LodashExtensions_1._isBlank)(examples)
            ? `<span class="_pale _oblique">(${t('survey:forExampleAbbreviation')}: ${examples})</span>`
            : '';
        return (t('visitedPlaces:LocationNameAddress', {
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        }) +
            ' ' +
            helpText);
    },
    conditional: function (interview, path) {
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        const activity = visitedPlace.activity;
        const person = odSurveyHelpers.getActivePerson({ interview });
        if (activity === 'workUsual' && person.usualWorkPlace && person.usualWorkPlace.name) {
            return [false, person.usualWorkPlace.name];
        }
        if (activity === 'schoolUsual' && person.usualSchoolPlace && person.usualSchoolPlace.name) {
            return [false, person.usualSchoolPlace.name];
        }
        const visitedPlaceAlreadyVisited = (0, helpers_1.getResponse)(interview, path, null, '../alreadyVisitedBySelfOrAnotherHouseholdMember');
        const shouldDisplay = !(0, LodashExtensions_1._isBlank)(activity) &&
            ![...types_1.loopActivities, 'home'].includes(activity) &&
            visitedPlaceAlreadyVisited !== 'yes';
        if (!shouldDisplay) {
            // Try to get the name from the shortcut if any
            if (visitedPlace.shortcut) {
                const shortcut = visitedPlace.shortcut;
                const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, shortcut, null);
                const shortcutVisitedPlaceName = shortcutVisitedPlace
                    ? (0, helper_1.getShortcutVisitedPlaceName)(shortcutVisitedPlace, interview)
                    : null;
                return [false, shortcutVisitedPlaceName];
            }
        }
        return [shouldDisplay, null];
    },
    defaultValue: function (interview, path) {
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        if (visitedPlace.shortcut) {
            const shortcut = visitedPlace.shortcut;
            const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, shortcut, null);
            const shortcutVisitedPlaceName = (0, helper_1.getShortcutVisitedPlaceName)(shortcutVisitedPlace, interview);
            if (shortcutVisitedPlaceName) {
                return shortcutVisitedPlaceName;
            }
        }
        return undefined;
    },
    validations: function (value, customValue, interview, path, customPath) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:activityDescriptionIsRequiredError')
            }
        ];
    }
};
exports.visitedPlaceGeography = {
    type: 'question',
    inputType: 'mapFindPlace',
    path: 'geography',
    datatype: 'geojson',
    containsHtml: true,
    height: '32rem',
    refreshGeocodingLabel: (t) => t('survey:visitedPlace:refreshGeocodingButton'),
    geocodingQueryString: function (interview, path) {
        return (0, helpers_1.formatGeocodingQueryStringFromMultipleFields)([(0, helpers_1.getResponse)(interview, path, null, '../name')]);
    },
    maxGeocodingResultsBounds: function (interview, path) {
        // FIXME Add this field to the config
        return project_config_1.default.mapMaxGeocodingResultsBounds;
    },
    invalidGeocodingResultTypes: [
        'political',
        'country',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'administrative_area_level_3',
        'administrative_area_level_4',
        'administrative_area_level_5',
        'administrative_area_level_6',
        'administrative_area_level_7',
        'colloquial_area',
        'locality',
        'sublocality',
        'sublocality_level_1',
        'sublocality_level_2',
        'sublocality_level_3',
        'sublocality_level_4',
        'sublocality_level_5',
        'neighborhood',
        'route'
    ],
    label: (t, interview) => t('visitedPlaces:geography'),
    icon: {
        url: function (interview, path) {
            const activity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
            const activityCategory = (0, helpers_1.getResponse)(interview, path, null, '../activityCategory');
            return (0, activityIconMapping_1.getActivityMarkerIcon)(activity || activityCategory);
        },
        size: [70, 70]
    },
    placesIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle.svg',
        size: [35, 35]
    },
    selectedIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    },
    defaultCenter: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = visitedPlace
            ? odSurveyHelpers.getPreviousVisitedPlace({ journey, visitedPlaceId: visitedPlace._uuid })
            : undefined;
        if (previousVisitedPlace) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            const geography = odSurveyHelpers.getVisitedPlaceGeography({ visitedPlace, interview, person });
            if (geography) {
                const coordinates = (0, get_1.default)(geography, 'geometry.coordinates', null);
                if (coordinates) {
                    return {
                        lat: coordinates[1],
                        lon: coordinates[0]
                    };
                }
            }
        }
        const homeCoordinates = (0, helpers_1.getResponse)(interview, 'home.geography.geometry.coordinates', null);
        return homeCoordinates
            ? {
                lat: homeCoordinates[1],
                lon: homeCoordinates[0]
            }
            : project_config_1.default.mapDefaultCenter;
    },
    defaultValue: function (interview, path) {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        if (visitedPlace.activity === 'workUsual' &&
            person.usualWorkPlace &&
            person.usualWorkPlace.geography) {
            return (0, cloneDeep_1.default)(person.usualWorkPlace.geography);
        }
        if (visitedPlace.activity === 'schoolUsual' &&
            person.usualSchoolPlace &&
            person.usualSchoolPlace.geography) {
            return (0, cloneDeep_1.default)(person.usualSchoolPlace.geography);
        }
        if (visitedPlace.shortcut) {
            const shortcut = visitedPlace.shortcut;
            const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, shortcut, null);
            const geography = shortcutVisitedPlace
                ? odSurveyHelpers.getVisitedPlaceGeography({ visitedPlace: shortcutVisitedPlace, interview, person })
                : null;
            if (shortcutVisitedPlace && !(0, LodashExtensions_1._isBlank)(geography)) {
                /* clone the original shortcuted geography,
                   otherwise it will change the lastAction of the
                   previous geography, which is not correct. */
                const clonedGeography = (0, cloneDeep_1.default)(geography);
                if (clonedGeography.properties === undefined) {
                    clonedGeography.properties = {};
                }
                clonedGeography.properties.lastAction = 'shortcut';
                return clonedGeography;
            }
        }
        return undefined;
    },
    updateDefaultValueWhenResponded: true,
    validations: function (value, customValue, interview, path, customPath) {
        var _a;
        const activity = (0, helpers_1.getResponse)(interview, path, null, '../activity');
        const geography = (0, helpers_1.getResponse)(interview, path, null, '../geography');
        const geocodingTextInput = geography ? (_a = geography.properties) === null || _a === void 0 ? void 0 : _a.geocodingQueryString : undefined;
        const validations = [
            {
                validation: ['home', ...types_1.loopActivities].indexOf(activity) <= -1 && (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:locationIsRequiredError')
            },
            {
                validation: geography &&
                    geography.properties.lastAction &&
                    (geography.properties.lastAction === 'mapClicked' ||
                        geography.properties.lastAction === 'markerDragged') &&
                    geography.properties.zoom < 15,
                errorMessage: (t) => t('survey:visitedPlace:locationIsNotPreciseError')
            },
            ...(0, customValidations_1.inaccessibleZoneGeographyCustomValidation)(geography, undefined, interview, path),
            {
                validation: geography && geography.properties.isGeocodingImprecise,
                errorMessage: {
                    fr: `<strong>Le nom du lieu utilisé pour effectuer la recherche ${!(0, LodashExtensions_1._isBlank)(geocodingTextInput) ? `("${geocodingTextInput}")` : ''} n'est pas assez précis.</strong> Ajoutez de l'information ou précisez l'emplacement à l'aide de la carte.`,
                    en: `<strong>The location name used for searching ${!(0, LodashExtensions_1._isBlank)(geocodingTextInput) ? `("${geocodingTextInput}")` : ''} is not specific enough.</strong> Please add more information or specify the location more precisely using the map.`
                }
            }
        ];
        return validations;
    },
    showSearchPlaceButton: (interview, path) => {
        // Do not show if the place is a shortcut
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        return (0, LodashExtensions_1._isBlank)(visitedPlace.shortcut);
    },
    conditional: function (interview, path) {
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        const activity = visitedPlace.activity;
        const person = odSurveyHelpers.getActivePerson({ interview });
        if (activity === 'workUsual' && person.usualWorkPlace && person.usualWorkPlace.geography) {
            return [false, person.usualWorkPlace.geography];
        }
        if (activity === 'schoolUsual' &&
            person.usualSchoolPlace &&
            person.usualSchoolPlace.geography) {
            return [false, person.usualSchoolPlace.geography];
        }
        const visitedPlaceAlreadyVisited = (0, helpers_1.getResponse)(interview, path, null, '../alreadyVisitedBySelfOrAnotherHouseholdMember');
        return [
            !(0, LodashExtensions_1._isBlank)(activity) &&
                ![...types_1.loopActivities, 'home'].includes(activity) &&
                !(visitedPlaceAlreadyVisited === 'yes' && (0, LodashExtensions_1._isBlank)(visitedPlace.shortcut)),
            null
        ];
    }
};
const getSuffixTimes = (interview, timeField = 'arrivalTime') => {
    // return an object: {[secondsSinceMidnight (string)]: suffix (string)}
    const suffixTimes = {};
    const journey = odSurveyHelpers.getActiveJourney({ interview });
    const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
    const isShortcut = activeVisitedPlace && activeVisitedPlace.shortcut;
    if (isShortcut) {
        const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, activeVisitedPlace.shortcut, null);
        const shortcutVisitedPlacePerson = shortcutVisitedPlace
            ? (0, helper_1.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview)
            : null;
        if (shortcutVisitedPlace &&
            shortcutVisitedPlace[timeField] &&
            shortcutVisitedPlacePerson &&
            shortcutVisitedPlacePerson.nickname) {
            suffixTimes[shortcutVisitedPlace[timeField].toString()] = ` (${(0, truncate_1.default)(shortcutVisitedPlacePerson.nickname, { length: 10 })})`;
        }
    }
    return suffixTimes;
};
exports.visitedPlacePreviousPreviousDepartureTime = Object.assign(Object.assign({}, defaultInputBase_1.inputTimeBase), { path: '_previousPreviousDepartureTime', twoColumns: false, containsHtml: true, addHourSeparators: true, minuteStep: 5, validations: validations.requiredValidation, conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        if (previousVisitedPlace &&
            previousVisitedPlace.activity &&
            (0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime) &&
            activeVisitedPlace.activity === 'workOnTheRoad' &&
            activeVisitedPlace.onTheRoadDepartureType === 'usualWorkPlace' &&
            previousVisitedPlace.activity !== 'workUsual') {
            return [true, null];
        }
        return [false, null];
    }, suffixTimes(interview, path) {
        // return an object: {[secondsSinceMidnight (string)]: suffix (string)}
        const suffixTimes = {};
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const isShortcut = activeVisitedPlace && activeVisitedPlace.shortcut;
        if (isShortcut) {
            const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, activeVisitedPlace.shortcut, null);
            const shortcutVisitedPlacePerson = shortcutVisitedPlace
                ? (0, helper_1.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview)
                : null;
            if (shortcutVisitedPlace &&
                shortcutVisitedPlace.arrivalTime &&
                shortcutVisitedPlacePerson &&
                shortcutVisitedPlacePerson.nickname) {
                suffixTimes[shortcutVisitedPlace.arrivalTime.toString()] = ` (${(0, truncate_1.default)(shortcutVisitedPlacePerson.nickname, { length: 10 })})`;
            }
        }
        return suffixTimes;
    }, minTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        // Start at 4 AM
        let lastTimeSecondsSinceMidnight = MIN_SECONDS_SINCE_MIDNIGHT;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesBeforeArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence < activeVisitedPlace._sequence;
            });
            const previousTimes = visitedPlacesBeforeArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight =
                previousTimes.length > 0 ? (0, max_1.default)(previousTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, maxTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        // Start at 4 AM
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousArrivalTime) &&
            visibleWidgets.includes(path.replace('._previousPreviousDepartureTime', '._previousArrivalTime'))) {
            return activeVisitedPlace._previousArrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousDepartureTime) &&
            visibleWidgets.includes(path.replace('._previousPreviousDepartureTime', '._previousDepartureTime'))) {
            return activeVisitedPlace._previousDepartureTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.arrivalTime) &&
            visibleWidgets.includes(path.replace('._previousPreviousDepartureTime', '.arrivalTime'))) {
            return activeVisitedPlace.arrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime) &&
            visibleWidgets.includes(path.replace('._previousPreviousDepartureTime', '.departureTime'))) {
            return activeVisitedPlace.departureTime;
        }
        let lastTimeSecondsSinceMidnight = 27 * 3600 + 59 * 60 + 59;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesAfterArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence > activeVisitedPlace._sequence;
            });
            const nextTimes = visitedPlacesAfterArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            // also check active departure time:
            if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime)) {
                nextTimes.push(activeVisitedPlace.departureTime);
            }
            lastTimeSecondsSinceMidnight = nextTimes.length > 0 ? (0, min_1.default)(nextTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        const onTheRoadDepartureType = activeVisitedPlace.onTheRoadDepartureType;
        const visitedPlaceDescription = (0, escape_1.default)((0, frontendHelper_1.getVisitedPlaceDescription)(activeVisitedPlace, false, false));
        if (previousVisitedPlace.activity === 'home' && onTheRoadDepartureType === 'usualWorkPlace') {
            return t('visitedPlaces:_previousPreviousDepartureTimeHomeToUsualWorkplace', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname: (0, escape_1.default)(person.nickname),
                visitedPlaceDescription,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
        else if (previousVisitedPlace.activity !== 'home' &&
            previousVisitedPlace.activity !== 'workUsual' &&
            onTheRoadDepartureType === 'usualWorkPlace') {
            return t('visitedPlaces:_previousPreviousDepartureTime', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname: (0, escape_1.default)(person.nickname),
                visitedPlaceDescription,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
    } });
exports.visitedPlacePreviousArrivalTime = Object.assign(Object.assign({}, defaultInputBase_1.inputTimeBase), { path: '_previousArrivalTime', twoColumns: false, containsHtml: true, addHourSeparators: true, minuteStep: 5, validations: validations.requiredValidation, conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        if (!previousVisitedPlace) {
            return [false, null];
        }
        if (activeVisitedPlace.activityCategory &&
            activeVisitedPlace.activity === 'workOnTheRoad' &&
            activeVisitedPlace.onTheRoadDepartureType) {
            if (activeVisitedPlace.onTheRoadDepartureType === 'home' &&
                previousVisitedPlace.activity !== 'home') {
                return [true, null];
            }
            else if (activeVisitedPlace.onTheRoadDepartureType === 'usualWorkPlace' &&
                previousVisitedPlace.activity !== 'workUsual') {
                return [true, null];
            }
        }
        return [false, null];
    }, suffixTimes(interview, path) {
        // FIXME Is this the same as the previousPrevious one? If so, extract
        const suffixTimes = {};
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const isShortcut = activeVisitedPlace && activeVisitedPlace.shortcut;
        if (isShortcut) {
            const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, activeVisitedPlace.shortcut, null);
            const shortcutVisitedPlacePerson = shortcutVisitedPlace
                ? (0, helper_1.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview)
                : null;
            if (shortcutVisitedPlace &&
                shortcutVisitedPlace.arrivalTime &&
                shortcutVisitedPlacePerson &&
                shortcutVisitedPlacePerson.nickname) {
                suffixTimes[shortcutVisitedPlace.arrivalTime.toString()] = ` (${(0, truncate_1.default)(shortcutVisitedPlacePerson.nickname, { length: 10 })})`;
            }
        }
        return suffixTimes;
    }, minTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousPreviousDepartureTime) &&
            visibleWidgets.includes(path.replace('._previousArrivalTime', '._previousPreviousDepartureTime'))) {
            return activeVisitedPlace._previousPreviousDepartureTime;
        }
        // Start at 4 AM
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        let lastTimeSecondsSinceMidnight = MIN_SECONDS_SINCE_MIDNIGHT;
        if (visitedPlacesArray.length > 1) {
            const visitedPlacesBeforeArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence < activeVisitedPlace._sequence;
            });
            const previousTimes = visitedPlacesBeforeArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight =
                previousTimes.length > 0 ? (0, max_1.default)(previousTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, maxTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousDepartureTime) &&
            visibleWidgets.includes(path.replace('._previousArrivalTime', '._previousDepartureTime'))) {
            return activeVisitedPlace._previousDepartureTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.arrivalTime) &&
            visibleWidgets.includes(path.replace('._previousArrivalTime', '.arrivalTime'))) {
            return activeVisitedPlace.arrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime) &&
            visibleWidgets.includes(path.replace('._previousArrivalTime', '.departureTime'))) {
            return activeVisitedPlace.departureTime;
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        let lastTimeSecondsSinceMidnight = 27 * 3600 + 59 * 60 + 59;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesAfterArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence > activeVisitedPlace._sequence;
            });
            const nextTimes = visitedPlacesAfterArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            // also check active departure time:
            if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime)) {
                nextTimes.push(activeVisitedPlace.departureTime);
            }
            lastTimeSecondsSinceMidnight = nextTimes.length > 0 ? (0, min_1.default)(nextTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const onTheRoadDepartureType = activeVisitedPlace.onTheRoadDepartureType;
        const visitedPlaceDescription = (0, escape_1.default)((0, frontendHelper_1.getVisitedPlaceDescription)(activeVisitedPlace, false, false));
        const nickname = (0, escape_1.default)(person.nickname);
        if (onTheRoadDepartureType === 'home') {
            return t('visitedPlaces:_previousArrivalTimeDepartureTypeHome', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname,
                visitedPlaceDescription,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
        else if (onTheRoadDepartureType === 'usualWorkPlace') {
            return t('visitedPlaces:_previousArrivalTimeDepartureTypeUsualWorkPlace', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname,
                visitedPlaceDescription,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
        else {
            return t('visitedPlaces:_previousArrivalTimeDepartureTypeOther', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname,
                visitedPlaceDescription,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
    } });
exports.visitedPlacePreviousDepartureTime = Object.assign(Object.assign({}, defaultInputBase_1.inputTimeBase), { path: '_previousDepartureTime', twoColumns: false, containsHtml: true, addHourSeparators: true, validations: validations.requiredValidation, minuteStep: (interview, path) => {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        return activeVisitedPlace._sequence === 2 && previousVisitedPlace._isNew !== false ? 15 : 5;
    }, conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        if (previousVisitedPlace && activeVisitedPlace.activity && (0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime)) {
            if (types_1.loopActivities.includes(activeVisitedPlace.activity)) {
                return [false, activeVisitedPlace.arrivalTime];
            }
            return [true, null];
        }
        return [false, null];
    }, suffixTimes(interview, path) {
        // return an object: {[secondsSinceMidnight (string)]: suffix (string)}
        const suffixTimes = {};
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const isShortcut = activeVisitedPlace && activeVisitedPlace.shortcut;
        if (isShortcut) {
            const shortcutVisitedPlace = (0, helpers_1.getResponse)(interview, activeVisitedPlace.shortcut, null);
            const shortcutVisitedPlacePerson = shortcutVisitedPlace
                ? (0, helper_1.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview)
                : null;
            if (shortcutVisitedPlace &&
                shortcutVisitedPlace.arrivalTime &&
                shortcutVisitedPlacePerson &&
                shortcutVisitedPlacePerson.nickname) {
                suffixTimes[shortcutVisitedPlace.arrivalTime.toString()] = ` (${(0, truncate_1.default)(shortcutVisitedPlacePerson.nickname, { length: 10 })})`;
            }
        }
        return suffixTimes;
    }, minTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousArrivalTime) &&
            visibleWidgets.includes(path.replace('._previousDepartureTime', '._previousArrivalTime'))) {
            return activeVisitedPlace._previousArrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousPreviousDepartureTime) &&
            visibleWidgets.includes(path.replace('._previousDepartureTime', '._previousPreviousDepartureTime'))) {
            return activeVisitedPlace._previousPreviousDepartureTime;
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        // Start at 4 AM
        let lastTimeSecondsSinceMidnight = MIN_SECONDS_SINCE_MIDNIGHT;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesBeforeArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence < activeVisitedPlace._sequence;
            });
            const previousTimes = visitedPlacesBeforeArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight =
                previousTimes.length > 0 ? (0, max_1.default)(previousTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, maxTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.arrivalTime) &&
            visibleWidgets.includes(path.replace('._previousDepartureTime', '.arrivalTime'))) {
            return activeVisitedPlace.arrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime) &&
            visibleWidgets.includes(path.replace('._previousDepartureTime', '.departureTime'))) {
            return activeVisitedPlace.departureTime;
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        let lastTimeSecondsSinceMidnight = MAX_SECONDS_SINCE_MIDNIGHT - 1; // 27:59:59
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesAfterArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence > activeVisitedPlace._sequence;
            });
            const nextTimes = visitedPlacesAfterArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            // also check active departure time:
            if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime)) {
                nextTimes.push(activeVisitedPlace.departureTime);
            }
            lastTimeSecondsSinceMidnight = nextTimes.length > 0 ? (0, min_1.default)(nextTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        const onTheRoadDepartureType = activeVisitedPlace.onTheRoadDepartureType;
        const visitedPlaceDescription = (0, escape_1.default)((0, frontendHelper_1.getVisitedPlaceDescription)(activeVisitedPlace, false, false));
        const previousVisitedPlaceDescription = (0, escape_1.default)((0, frontendHelper_1.getVisitedPlaceDescription)(previousVisitedPlace, false, false));
        let key = 'visitedPlaces:PreviousDepartureTime';
        if (previousVisitedPlace.activity === 'home' && activeVisitedPlace.activity === 'workUsual') {
            key = 'visitedPlaces:PreviousDepartureTime_home_workUsual';
        }
        else if (previousVisitedPlace.activity === 'home' && activeVisitedPlace.activity === 'schoolUsual') {
            key = 'visitedPlaces:PreviousDepartureTime_home_schoolUsual';
        }
        else if (previousVisitedPlace.activity === 'home' &&
            previousVisitedPlace._sequence === 1 &&
            !types_1.loopActivities.includes(activeVisitedPlace.activity)) {
            key = 'visitedPlaces:PreviousDepartureTime_home_other';
        }
        else if (previousVisitedPlace.activity === 'home' && activeVisitedPlace.activity === 'workOnTheRoad') {
            key = 'visitedPlaces:PreviousDepartureTime_home_workOnTheRoad';
        }
        else if (onTheRoadDepartureType === 'usualWorkPlace' && activeVisitedPlace.activity === 'workOnTheRoad') {
            key = 'visitedPlaces:PreviousDepartureTime_usualWorkPlace_workOnTheRoad';
        }
        return t(key, {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            nickname: (0, escape_1.default)(person.nickname),
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person }),
            previousVisitedPlaceDescription,
            visitedPlaceDescription
        });
    } });
exports.visitedPlaceArrivalTime = Object.assign(Object.assign({}, defaultInputBase_1.inputTimeBase), { path: 'arrivalTime', twoColumns: false, containsHtml: true, addHourSeparators: true, minuteStep: 5, validations: validations.requiredValidation, conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        const previousArrivalTime = activeVisitedPlace._previousArrivalTime;
        const previousArrivalTimeIsVisible = interview.visibleWidgets.includes(path.replace('departureTime', '_previousArrivalTime'));
        if (activeVisitedPlace.onTheRoadDepartureType === 'home' && previousVisitedPlace.activity !== 'home') {
            return [true, null];
        }
        else if (activeVisitedPlace.onTheRoadDepartureType === 'usualWorkPlace' &&
            previousVisitedPlace.activity !== 'workUsual') {
            return [true, null];
        }
        if (previousArrivalTimeIsVisible && (0, LodashExtensions_1._isBlank)(previousArrivalTime)) {
            return [false, null];
        }
        if (previousVisitedPlace &&
            types_1.loopActivities.includes(activeVisitedPlace.activity) &&
            !(0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime)) {
            return [false, previousVisitedPlace.departureTime];
        }
        if (previousVisitedPlace &&
            types_1.loopActivities.includes(previousVisitedPlace.activity) &&
            !(0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime)) {
            return [false, previousVisitedPlace.departureTime];
        }
        return [activeVisitedPlace.activity && activeVisitedPlace._sequence > 1, null];
    }, suffixTimes(interview, path) {
        const suffixTimes = getSuffixTimes(interview, 'arrivalTime');
        suffixTimes[MAX_SECONDS_SINCE_MIDNIGHT] = ' ' + i18n_config_1.default.t('survey:orPlus');
        // Add round travel time suffixes up to 2 hours
        // disable suffix for now: TODO: find a better way to show travel times?
        /*if (activeVisitedPlace._sequence && activeVisitedPlace._sequence > 1) {
            const person = helper.getPerson(interview);
            const visitedPlaces = helper.getVisitedPlaces(person, null, true);
            const lastVisitedPlace = visitedPlaces[activeVisitedPlace._sequence - 2];
            if (!_isBlank(lastVisitedPlace) && !_isBlank(lastVisitedPlace.departureTime)) {
                const roundTimes = {
                    '(15min)': 15,
                    '(30min)': 30,
                    '(45min)': 45,
                    '(1h)': 60,
                    '(1h15)': 75,
                    '(1h30)': 90,
                    '(1h45)': 105,
                    '(2h)': 120
                };
                Object.keys(roundTimes).forEach(roundTimeStr => {
                    const timeStr = (lastVisitedPlace.departureTime + (roundTimes[roundTimeStr] * 60)).toString();
                    suffixTimes[timeStr] = suffixTimes[timeStr] !== undefined ? ` ${roundTimeStr} ${suffixTimes[timeStr]}` : ` ${roundTimeStr}`;
                });
            }
        }*/
        return suffixTimes;
    }, minTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        // FIXME This deserves a comment. Why? It was copy-pasted, but seriously, what does this do? Why only if the widget is visible?
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousDepartureTime) &&
            visibleWidgets.includes(path.replace('.arrivalTime', '._previousDepartureTime'))) {
            return activeVisitedPlace._previousDepartureTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousArrivalTime) &&
            visibleWidgets.includes(path.replace('.arrivalTime', '._previousArrivalTime'))) {
            return activeVisitedPlace._previousArrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousPreviousDepartureTime) &&
            visibleWidgets.includes(path.replace('.arrivalTime', '._previousPreviousDepartureTime'))) {
            return activeVisitedPlace._previousPreviousDepartureTime;
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        let lastTimeSecondsSinceMidnight = MIN_SECONDS_SINCE_MIDNIGHT;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesBeforeArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence < activeVisitedPlace._sequence;
            });
            const previousTimes = visitedPlacesBeforeArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight =
                previousTimes.length > 0 ? (0, max_1.default)(previousTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, maxTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime) &&
            visibleWidgets.includes(path.replace('.arrivalTime', '.departureTime'))) {
            return activeVisitedPlace.departureTime;
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        //let lastTimeSecondsSinceMidnight = 27 * 3600 + 59 * 60 + 59;
        // include 4:00 for later trips:
        let lastTimeSecondsSinceMidnight = MAX_SECONDS_SINCE_MIDNIGHT;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesAfterArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence > activeVisitedPlace._sequence;
            });
            const nextTimes = visitedPlacesAfterArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            // also check active departure time:
            if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.departureTime)) {
                nextTimes.push(activeVisitedPlace.departureTime);
            }
            lastTimeSecondsSinceMidnight = nextTimes.length > 0 ? (0, min_1.default)(nextTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlaceName = activeVisitedPlace === null || activeVisitedPlace === void 0 ? void 0 : activeVisitedPlace.name;
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        const previousVisitedPlaceDepartureTime = activeVisitedPlace._previousDepartureTime
            ? activeVisitedPlace._previousDepartureTime
            : previousVisitedPlace
                ? previousVisitedPlace.departureTime
                : null;
        let durationText = '';
        if (previousVisitedPlaceDepartureTime &&
            activeVisitedPlace._sequence &&
            activeVisitedPlace._sequence > 1 &&
            !activeVisitedPlace._previousArrivalTime &&
            !types_1.loopActivities.includes(activeVisitedPlace.activity) &&
            (!previousVisitedPlace || !types_1.loopActivities.includes(previousVisitedPlace.activity))) {
            durationText = (0, helper_1.formatTripDuration)(activeVisitedPlace.arrivalTime, previousVisitedPlaceDepartureTime, i18n_config_1.default.language);
        }
        let key = 'visitedPlaces:arrivalTime';
        if (activeVisitedPlace && activeVisitedPlace.activity === 'workOnTheRoad') {
            key = 'visitedPlaces:arrivalTimeOnTheRoad';
        }
        else if (activeVisitedPlace && activeVisitedPlace.activity === 'leisureStroll') {
            key = 'visitedPlaces:arrivalTimeStroll';
        }
        const place = !(0, LodashExtensions_1._isBlank)(visitedPlaceName)
            ? t('survey:atPlace', { placeName: (0, escape_1.default)(visitedPlaceName) })
            : t('survey:atThisPlace', { context: activeVisitedPlace.activity });
        return (t(key, {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            nickname: (0, escape_1.default)(person.nickname),
            atPlace: place,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        }) + durationText);
    } });
exports.visitedPlaceNextPlaceCategory = {
    type: 'question',
    inputType: 'radio',
    path: 'nextPlaceCategory',
    datatype: 'string',
    twoColumns: false,
    sameLine: false,
    containsHtml: true,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlaceName = activeVisitedPlace === null || activeVisitedPlace === void 0 ? void 0 : activeVisitedPlace.name;
        const atPlace = !(0, LodashExtensions_1._isBlank)(visitedPlaceName)
            ? t('survey:atPlace', { placeName: (0, escape_1.default)(visitedPlaceName) })
            : t('survey:atThisPlace', { context: activeVisitedPlace.activity });
        return t('visitedPlaces:nextPlaceCategory', {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            nickname: (0, escape_1.default)(person.nickname),
            atPlace,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    choices: [
        {
            value: 'wentBackHome',
            label: (t, interview, path) => {
                const person = odSurveyHelpers.getActivePerson({ interview });
                const homeAddress = (0, helper_1.getHomeAddressOneLine)(interview);
                return t('visitedPlaces:nextPlaceRadioChoices.wentBackHome', {
                    address: homeAddress,
                    context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth)
                });
            },
            conditional: function (interview) {
                const journey = odSurveyHelpers.getActiveJourney({ interview });
                const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
                return activeVisitedPlace.activity !== 'home' && activeVisitedPlace.activity !== 'workOnTheRoad';
            }
        },
        {
            value: 'visitedAnotherPlace',
            label: (t, interview) => {
                const person = odSurveyHelpers.getActivePerson({ interview });
                return t('visitedPlaces:nextPlaceRadioChoices.visitedAnotherPlace', {
                    context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth)
                });
            }
        },
        {
            value: 'stayedThereUntilTheNextDay',
            label: (t, interview, path) => {
                const person = odSurveyHelpers.getActivePerson({ interview });
                const journey = odSurveyHelpers.getActiveJourney({ interview });
                const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
                if (activeVisitedPlace.activityCategory === 'home') {
                    return t('visitedPlaces:nextPlaceRadioChoices.stayedHomeUntilTheNextDay', {
                        context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth)
                    });
                }
                else {
                    return t('visitedPlaces:nextPlaceRadioChoices.stayedThereUntilTheNextDay', {
                        context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth)
                    });
                }
            },
            conditional: function (interview) {
                const journey = odSurveyHelpers.getActiveJourney({ interview });
                const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
                const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
                return (visitedPlacesArray.length > 1 &&
                    visitedPlacesArray[visitedPlacesArray.length - 1]._uuid === activeVisitedPlace._uuid);
            }
        },
        {
            label: '',
            value: 'wentToUsualWorkPlace',
            hidden: true // used for workOnTheRoad trips only, imputed
        }
    ],
    validations: validations.requiredValidation,
    conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const nextVisitedPlace = odSurveyHelpers.getNextVisitedPlace({
            journey,
            visitedPlaceId: activeVisitedPlace._uuid
        });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        if (activeVisitedPlace.arrivalTime && activeVisitedPlace.arrivalTime === MAX_SECONDS_SINCE_MIDNIGHT) {
            return [false, 'stayedThereUntilTheNextDay'];
        }
        if (types_1.loopActivities.includes(activeVisitedPlace.activity) &&
            activeVisitedPlace.onTheRoadArrivalType === 'stayedThereUntilTheNextDay') {
            return [false, 'stayedThereUntilTheNextDay'];
        }
        if (activeVisitedPlace.activity &&
            visitedPlacesArray[visitedPlacesArray.length - 1]._uuid === activeVisitedPlace._uuid &&
            activeVisitedPlace.activity !== 'workOnTheRoad') {
            // last vp
            return [true, null];
        }
        if (!nextVisitedPlace) {
            return [false, null];
        }
        return [
            activeVisitedPlace.activity && !nextVisitedPlace && !types_1.loopActivities.includes(activeVisitedPlace.activity),
            null
        ];
    }
};
exports.visitedPlaceDepartureTime = Object.assign(Object.assign({}, defaultInputBase_1.inputTimeBase), { path: 'departureTime', twoColumns: false, containsHtml: true, addHourSeparators: true, validations: validations.requiredValidation, minuteStep: (interview, path) => {
        const visitedPlace = (0, helpers_1.getResponse)(interview, path, null, '../');
        return visitedPlace._sequence === 1 && visitedPlace._isNew !== false ? 15 : 5;
    }, conditional: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        if (activeVisitedPlace.activity &&
            activeVisitedPlace.onTheRoadArrivalType &&
            activeVisitedPlace.onTheRoadArrivalType !== 'stayedThereUntilTheNextDay') {
            return [true, null];
        }
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        if ((0, LodashExtensions_1._isBlank)(activeVisitedPlace.nextPlaceCategory) &&
            visitedPlacesArray.length > 1 &&
            visitedPlacesArray[visitedPlacesArray.length - 1]._uuid === activeVisitedPlace._uuid) {
            return [false, null];
        }
        return [
            activeVisitedPlace.activityCategory &&
                (activeVisitedPlace._sequence === 1 ||
                    activeVisitedPlace.nextPlaceCategory !== 'stayedThereUntilTheNextDay'),
            null
        ];
    }, suffixTimes(interview, path) {
        return getSuffixTimes(interview, 'departureTime');
    }, minTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visibleWidgets = interview.visibleWidgets;
        if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace.arrivalTime) &&
            visibleWidgets.includes(path.replace('.departureTime', '.arrivalTime'))) {
            return activeVisitedPlace.arrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousDepartureTime) &&
            visibleWidgets.includes(path.replace('.departureTime', '._previousDepartureTime'))) {
            return activeVisitedPlace._previousDepartureTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousArrivalTime) &&
            visibleWidgets.includes(path.replace('.departureTime', '._previousArrivalTime'))) {
            return activeVisitedPlace._previousArrivalTime;
        }
        else if (!(0, LodashExtensions_1._isBlank)(activeVisitedPlace._previousPreviousDepartureTime) &&
            visibleWidgets.includes(path.replace('.departureTime', '._previousPreviousDepartureTime'))) {
            return activeVisitedPlace._previousPreviousDepartureTime;
        }
        // Start at 4 AM
        let lastTimeSecondsSinceMidnight = MIN_SECONDS_SINCE_MIDNIGHT;
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesBeforeArray = visitedPlacesArray.filter((visitedPlace) => {
                return visitedPlace._sequence < activeVisitedPlace._sequence;
            });
            const previousTimes = visitedPlacesBeforeArray.map((visitedPlace) => {
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
                    return visitedPlace.arrivalTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight =
                previousTimes.length > 0 ? (0, max_1.default)(previousTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, maxTimeSecondsSinceMidnight: function (interview, path) {
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const activeVisitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const visitedPlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey });
        let lastTimeSecondsSinceMidnight = 27 * 3600 + 59 * 60 + 59;
        if (visitedPlacesArray.length > 0) {
            const visitedPlacesAfterArray = visitedPlacesArray.filter((visitedPlace) => {
                return (visitedPlace._sequence > activeVisitedPlace._sequence &&
                    !types_1.loopActivities.includes(visitedPlace.activity));
            });
            const isMovingActivity = types_1.loopActivities.includes(activeVisitedPlace.activity);
            const nextTimes = visitedPlacesAfterArray.map((visitedPlace) => {
                // Use arrivalTime if available and the activity is not a moving activity, otherwise, prefer departure time
                if (!(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime) && !isMovingActivity) {
                    return visitedPlace.arrivalTime;
                }
                else if (!(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
                    return visitedPlace.departureTime;
                }
                return lastTimeSecondsSinceMidnight;
            });
            lastTimeSecondsSinceMidnight = nextTimes.length > 0 ? (0, min_1.default)(nextTimes) : lastTimeSecondsSinceMidnight;
        }
        return lastTimeSecondsSinceMidnight;
    }, label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey });
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            journey,
            visitedPlaceId: visitedPlace._uuid
        });
        const previousVisitedPlaceDepartureTime = visitedPlace._previousDepartureTime
            ? visitedPlace._previousDepartureTime
            : previousVisitedPlace
                ? previousVisitedPlace.departureTime
                : null;
        let durationText = '';
        if (previousVisitedPlaceDepartureTime &&
            visitedPlace._sequence &&
            visitedPlace._sequence > 1 &&
            !!previousVisitedPlace &&
            types_1.loopActivities.includes(previousVisitedPlace.activity)) {
            durationText = (0, helper_1.formatTripDuration)(visitedPlace.arrivalTime, previousVisitedPlaceDepartureTime, i18n_config_1.default.language);
        }
        if (visitedPlace.activity === 'workOnTheRoad') {
            return (t('visitedPlaces:departureTimeOnTheRoad', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            }) + durationText);
        }
        else if (visitedPlace.activity === 'leisureStroll') {
            return (t('visitedPlaces:departureTimeStroll', {
                context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
                nickname,
                count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
            }) + durationText);
        }
        const visitedPlaceName = visitedPlace.name;
        const place = visitedPlace.activity === 'home' || visitedPlace.activityCategory === 'home'
            ? t('survey:theHome')
            : !(0, LodashExtensions_1._isBlank)(visitedPlaceName)
                ? t('survey:place', { placeName: (0, escape_1.default)(visitedPlaceName) })
                : t('survey:thisPlace', { context: visitedPlace.activity });
        return t('visitedPlaces:departureTime', {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person }),
            place: place
        });
    } });
exports.buttonSaveVisitedPlace = {
    type: 'button',
    color: 'green',
    label: (t) => t('main:Confirm'),
    hideWhenRefreshing: true,
    path: 'saveVisitedPlace',
    icon: free_solid_svg_icons_1.faCheckCircle,
    align: 'center',
    saveCallback: function (callbacks, interview, path) {
        // FIXME There's a lot of redundant code in this function, refactor when
        // we have time and see if we really need that many calls to
        // startUpdateInterview
        const person = odSurveyHelpers.getPerson({ interview });
        const currentJourney = odSurveyHelpers.getActiveJourney({ interview, person });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey: currentJourney });
        const visitedPlacePath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${visitedPlace._uuid}`;
        const previousVisitedPlace = odSurveyHelpers.getPreviousVisitedPlace({
            visitedPlaceId: visitedPlace._uuid,
            journey: currentJourney
        });
        const previousVisitedPlacePath = previousVisitedPlace
            ? `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${previousVisitedPlace._uuid}`
            : null;
        const nextVisitedPlace = odSurveyHelpers.getNextVisitedPlace({
            visitedPlaceId: visitedPlace._uuid,
            journey: currentJourney
        });
        const nextVisitedPlacePath = nextVisitedPlace
            ? `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${nextVisitedPlace._uuid}`
            : null;
        const updateValuesbyPath = {};
        // for on the road with insertion between previous and on the road vp:
        if (previousVisitedPlace &&
            (0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime) &&
            !(0, LodashExtensions_1._isBlank)(visitedPlace._previousPreviousDepartureTime)) {
            updateValuesbyPath[`response.${previousVisitedPlacePath}.departureTime`] = visitedPlace._previousPreviousDepartureTime;
            updateValuesbyPath[`response.${previousVisitedPlacePath}._isNew`] = false;
        }
        else if (previousVisitedPlace &&
            (0, LodashExtensions_1._isBlank)(previousVisitedPlace.departureTime) &&
            !(0, LodashExtensions_1._isBlank)(visitedPlace._previousDepartureTime)) {
            updateValuesbyPath[`response.${previousVisitedPlacePath}.departureTime`] = visitedPlace._previousDepartureTime;
            updateValuesbyPath[`response.${previousVisitedPlacePath}._isNew`] = false;
        }
        updateValuesbyPath[`response.${visitedPlacePath}._isNew`] = false;
        // Match arrival/departure time of moving activities with the previous/next times
        if (nextVisitedPlace &&
            (types_1.loopActivities.includes(nextVisitedPlace.activity) || types_1.loopActivities.includes(visitedPlace.activity))) {
            updateValuesbyPath[`response.${nextVisitedPlacePath}.arrivalTime`] = visitedPlace.departureTime;
        }
        let addedGroupedObjectBefore = undefined;
        let addedGroupedObjectAfter = undefined;
        // on the road departure: home but previous is not home: insert home before on the road:
        if (visitedPlace.onTheRoadDepartureType === 'home' &&
            (!previousVisitedPlace || previousVisitedPlace.activity !== 'home')) {
            addedGroupedObjectBefore = {
                sequence: visitedPlace._sequence,
                path: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`,
                object: {
                    activity: 'home',
                    activityCategory: 'home',
                    nextPlaceCategory: 'visitedAnotherPlace',
                    arrivalTime: visitedPlace._previousArrivalTime
                        ? visitedPlace._previousArrivalTime
                        : undefined,
                    departureTime: types_1.loopActivities.includes(visitedPlace.activity) ? visitedPlace.arrivalTime : undefined
                }
            };
            // on the road departure: usual work place but previous is not workUsual: insert work usual before on the road:
        }
        else if (visitedPlace.onTheRoadDepartureType === 'usualWorkPlace' &&
            (!previousVisitedPlace || previousVisitedPlace.activity !== 'workUsual')) {
            addedGroupedObjectBefore = {
                sequence: visitedPlace._sequence,
                path: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`,
                object: {
                    activity: 'workUsual',
                    activityCategory: 'work',
                    nextPlaceCategory: 'visitedAnotherPlace',
                    arrivalTime: visitedPlace._previousArrivalTime
                        ? visitedPlace._previousArrivalTime
                        : undefined,
                    departureTime: visitedPlace.activity === 'workOnTheRoad' ? visitedPlace.arrivalTime : undefined
                }
            };
        }
        // next place category or on the road arrival type is workUsual but next is not workUsusal: insert workUsual after:
        if ((visitedPlace.nextPlaceCategory === 'wentToUsualWorkPlace' ||
            visitedPlace.onTheRoadArrivalType === 'usualWorkPlace') &&
            (!nextVisitedPlace || nextVisitedPlace.activity !== 'workUsual')) {
            addedGroupedObjectAfter = {
                sequence: visitedPlace._sequence + 1,
                path: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`,
                object: {
                    activity: 'workUsual',
                    activityCategory: 'work',
                    arrivalTime: visitedPlace.activity === 'workOnTheRoad' ? visitedPlace.departureTime : undefined
                }
            };
            // next place category is other but next is not other: insert other after:
        }
        else if ((visitedPlace.nextPlaceCategory === 'visitedAnotherPlace' ||
            visitedPlace.onTheRoadArrivalType === 'other') &&
            (!nextVisitedPlace ||
                nextVisitedPlace.activityCategory === 'home' ||
                (visitedPlace.activityCategory === 'work' &&
                    visitedPlace.activity === 'workOnTheRoad' &&
                    nextVisitedPlace.activity === 'workUsual'))) {
            addedGroupedObjectAfter = {
                sequence: visitedPlace._sequence + 1,
                path: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`,
                object: {
                    arrivalTime: types_1.loopActivities.includes(visitedPlace.activity) ? visitedPlace.departureTime : undefined
                }
            };
            // next place category is home but next is not home: insert home after:
        }
        else if ((visitedPlace.nextPlaceCategory === 'wentBackHome' ||
            visitedPlace.onTheRoadArrivalType === 'home') &&
            !(0, LodashExtensions_1._isBlank)(visitedPlace.activityCategory) &&
            visitedPlace.activityCategory !== 'home' &&
            (!nextVisitedPlace || nextVisitedPlace.activityCategory !== 'home')) {
            addedGroupedObjectAfter = {
                sequence: visitedPlace._sequence + 1,
                path: `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`,
                object: {
                    activity: 'home',
                    activityCategory: 'home',
                    arrivalTime: types_1.loopActivities.includes(visitedPlace.activity) ? visitedPlace.departureTime : undefined
                }
            };
        }
        if (addedGroupedObjectBefore && addedGroupedObjectAfter) {
            const addValuesByPathForBefore = (0, helpers_1.addGroupedObjects)(interview, 1, addedGroupedObjectBefore.sequence, addedGroupedObjectBefore.path, [addedGroupedObjectBefore.object]);
            callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: addValuesByPathForBefore }, (_interview) => {
                const addValuesByPathForAfter = (0, helpers_1.addGroupedObjects)(_interview, 1, addedGroupedObjectAfter.sequence + 1, addedGroupedObjectAfter.path, [addedGroupedObjectAfter.object]);
                callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: addValuesByPathForAfter }, () => {
                    callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: updateValuesbyPath }, (_interview2) => {
                        const _person = odSurveyHelpers.getPerson({ interview: _interview2 });
                        const _journey = odSurveyHelpers.getActiveJourney({
                            interview: _interview2,
                            person: _person
                        });
                        const _visitedPlaces = odSurveyHelpers.getVisitedPlacesArray({ journey: _journey });
                        const nextIncompletePlace = (0, helper_1.selectNextIncompleteVisitedPlace)({
                            visitedPlaces: _visitedPlaces,
                            person: _person,
                            interview: _interview2
                        });
                        const _updateValuesbyPath = {
                            // we need to update twice to get changes to all vps (they may be completed in the udpate) before selecting an incomplete vp:
                            ['response._activeVisitedPlaceId']: nextIncompletePlace
                                ? nextIncompletePlace._uuid
                                : null
                        };
                        callbacks.startUpdateInterview({
                            sectionShortname: 'visitedPlaces',
                            valuesByPath: _updateValuesbyPath
                        });
                    });
                });
            });
            return null;
        }
        else if (addedGroupedObjectBefore) {
            const addValuesByPathForBefore = (0, helpers_1.addGroupedObjects)(interview, 1, addedGroupedObjectBefore.sequence, addedGroupedObjectBefore.path, [addedGroupedObjectBefore.object]);
            callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: addValuesByPathForBefore }, () => {
                callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: updateValuesbyPath }, (_interview) => {
                    const _person = odSurveyHelpers.getPerson({ interview: _interview });
                    const _journey = odSurveyHelpers.getActiveJourney({
                        interview: _interview,
                        person: _person
                    });
                    const _visitedPlaces = odSurveyHelpers.getVisitedPlacesArray({ journey: _journey });
                    const nextIncompletePlace = (0, helper_1.selectNextIncompleteVisitedPlace)({
                        visitedPlaces: _visitedPlaces,
                        person: _person,
                        interview: _interview
                    });
                    const _updateValuesbyPath = {
                        // we need to update twice to get changes to all vps (they may be completed in the udpate) before selecting an incomplete vp:
                        ['response._activeVisitedPlaceId']: nextIncompletePlace
                            ? nextIncompletePlace._uuid
                            : null
                    };
                    callbacks.startUpdateInterview({
                        sectionShortname: 'visitedPlaces',
                        valuesByPath: _updateValuesbyPath
                    });
                });
            });
            return null;
        }
        else if (addedGroupedObjectAfter) {
            const addValuesByPathForAfter = (0, helpers_1.addGroupedObjects)(interview, 1, addedGroupedObjectAfter.sequence, addedGroupedObjectAfter.path, [addedGroupedObjectAfter.object]);
            callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: addValuesByPathForAfter }, () => {
                callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: updateValuesbyPath }, (_interview) => {
                    const _person = odSurveyHelpers.getPerson({ interview: _interview });
                    const _journey = odSurveyHelpers.getActiveJourney({
                        interview: _interview,
                        person: _person
                    });
                    const _visitedPlaces = odSurveyHelpers.getVisitedPlacesArray({ journey: _journey });
                    const nextIncompletePlace = (0, helper_1.selectNextIncompleteVisitedPlace)({
                        visitedPlaces: _visitedPlaces,
                        person: _person,
                        interview: _interview
                    });
                    const _updateValuesbyPath = {
                        // we need to update twice to get changes to all vps (they may be completed in the udpate) before selecting an incomplete vp:
                        ['response._activeVisitedPlaceId']: nextIncompletePlace
                            ? nextIncompletePlace._uuid
                            : null
                    };
                    callbacks.startUpdateInterview({
                        sectionShortname: 'visitedPlaces',
                        valuesByPath: _updateValuesbyPath
                    });
                });
            });
            return null;
        }
        else {
            callbacks.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: updateValuesbyPath }, (_interview) => {
                const _person = odSurveyHelpers.getPerson({ interview: _interview });
                const _journey = odSurveyHelpers.getActiveJourney({ interview: _interview, person: _person });
                const _visitedPlaces = odSurveyHelpers.getVisitedPlacesArray({ journey: _journey });
                const nextIncompletePlace = (0, helper_1.selectNextIncompleteVisitedPlace)({
                    visitedPlaces: _visitedPlaces,
                    person: _person,
                    interview: _interview
                });
                const _updateValuesbyPath = {
                    // we need to update twice to get changes to all vps (they may be completed in the udpate) before selecting an incomplete vp:
                    ['response._activeVisitedPlaceId']: nextIncompletePlace ? nextIncompletePlace._uuid : null
                };
                callbacks.startUpdateInterview({
                    sectionShortname: 'visitedPlaces',
                    valuesByPath: _updateValuesbyPath
                });
            });
            return null;
        }
    },
    action: frontendHelper_1.validateButtonAction
};
// FIXME This button is the same as the delete button, except the condition who here needs the blank category, while the other for the the not blank category
exports.buttonCancelVisitedPlace = {
    type: 'button',
    color: 'grey',
    label: (t) => t('main:Cancel'),
    hideWhenRefreshing: true,
    path: 'cancelVisitedPlace',
    conditional: function (interview, path) {
        const person = odSurveyHelpers.getPerson({ interview });
        const currentJourney = odSurveyHelpers.getActiveJourney({ interview, person });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey: currentJourney });
        const visitePlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey: currentJourney });
        return [visitePlacesArray.length > 1 && (0, LodashExtensions_1._isBlank)(visitedPlace.activityCategory), undefined];
    },
    //icon: faCheckCircle,
    align: 'center',
    size: 'small',
    action: function (callbacks, interview, path, section, sections, saveCallback) {
        const visitedPlacePath = (0, helpers_1.getPath)(path, '../');
        (0, helper_1.deleteVisitedPlace)(visitedPlacePath, interview, callbacks.startRemoveGroupedObjects, callbacks.startUpdateInterview);
    }
};
// FIXME Differs from cancel by the conditional and the popup
exports.buttonDeleteVisitedPlace = {
    type: 'button',
    color: 'red',
    icon: free_solid_svg_icons_1.faTrashAlt,
    label: (t) => t('survey:DeleteLocation'),
    hideWhenRefreshing: true,
    path: 'deleteVisitedPlace',
    conditional: function (interview, path) {
        const person = odSurveyHelpers.getPerson({ interview });
        const currentJourney = odSurveyHelpers.getActiveJourney({ interview, person });
        const visitedPlace = odSurveyHelpers.getActiveVisitedPlace({ interview, journey: currentJourney });
        const visitePlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey: currentJourney });
        return [visitePlacesArray.length > 1 && !(0, LodashExtensions_1._isBlank)(visitedPlace.activityCategory), undefined];
    },
    align: 'center',
    size: 'small',
    confirmPopup: {
        content: (t) => t('survey:ConfirmDeleteLocation')
    },
    action: function (callbacks, interview, path, section, sections, saveCallback) {
        const visitedPlacePath = (0, helpers_1.getPath)(path, '../');
        (0, helper_1.deleteVisitedPlace)(visitedPlacePath, interview, callbacks.startRemoveGroupedObjects, callbacks.startUpdateInterview);
    }
};
exports.buttonVisitedPlacesConfirmNextSection = Object.assign(Object.assign({}, defaultInputBase_1.buttonNextBase), { path: 'visitedPlaces.save', label: (t) => t('visitedPlaces:visitedPlaces.save'), conditional: (interview, path) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const currentJourney = odSurveyHelpers.getActiveJourney({ interview, person });
        const visitePlacesArray = odSurveyHelpers.getVisitedPlacesArray({ journey: currentJourney });
        const lastVisitedPlace = visitePlacesArray[visitePlacesArray.length - 1];
        return !!(lastVisitedPlace && lastVisitedPlace.nextPlaceCategory === 'stayedThereUntilTheNextDay');
    } });
